import React, { useEffect, useState } from 'react';
import IncrementButton from '../../buttons/incrementButton/IncrementButton';
import NumberInputWithUnit from '../numberInputWithUnit/NumberInputWithUnit';
import Tag from '../tagInput/Tag';
import style from './ValueListInput.module.css';
import PropTypes from 'prop-types';
import { colors } from '../../../../colorVars';

function ValueListInput({
  symbol,
  onAddDelete,
  direction,
  currentValues,
  buttonBgColor,
  buttonColor,
  addDecimals,
  allowRepeats,
  percentageArray,
  disabled,
  inputWidth,
}) {
  const [valueList, setValueList] = useState([]);
  const [inputVal, setInputVal] = useState(0);
  const [isInList, setIsInList] = useState(false);

  const removeFromList = (index) => {
    const copy = [...valueList];
    if (copy.length === 1) {
      setValueList([]);
      onAddDelete([]);
    } else {
      copy.splice(index, 1);
      setValueList([...copy]);
      onAddDelete(copy);
    }
  };
  const stringListToArray = (list) => {
    if (Array.isArray(list)) {
      return list;
    } else {
      if (!list?.length) return [];
      else return list.split(',');
    }
  };
  const addToList = () => {
    if (addDecimals) {
      const decimalString = Number(inputVal).toFixed(2).toString();
      if (!allowRepeats && valueList.includes(decimalString)) return;
      onAddDelete([...valueList, decimalString]);
      setValueList((prev) => [...prev, decimalString]);
    } else {
      if (!allowRepeats && valueList.includes(inputVal)) return;
      onAddDelete([...valueList, inputVal]);
      setValueList((prev) => [...prev, inputVal]);
    }
  };

  useEffect(() => {
    if (percentageArray) {
      if (addDecimals)
        setValueList(
          currentValues.map((item) => {
            const percent = Number(item) * 100;
            return percent.toFixed(2).toString();
          })
        );
      else
        setValueList(
          currentValues.map((item) => {
            const percent = Number(item) * 100;
            return percent.toString();
          })
        );
    } else {
      if (addDecimals)
        setValueList(
          stringListToArray(currentValues).map((item) =>
            Number(item).toFixed(2).toString()
          )
        );
      else setValueList(stringListToArray(currentValues));
    }
  }, [currentValues]);

  useEffect(() => {
    if (addDecimals) {
      if (valueList.includes(Number(inputVal).toFixed(2).toString()))
        setIsInList(true);
      else setIsInList(false);
    } else {
      if (valueList.includes(inputVal)) setIsInList(true);
      else setIsInList(false);
    }
  }, [inputVal, valueList]);

  return (
    <div>
      <div className={style.list}>
        {valueList.map((value, index) => (
          <Tag
            key={value + index + ''}
            closeHandler={(index) => {
              removeFromList(index);
            }}
            index={index}
          >
            {direction === 'left' ? symbol + value : value + symbol}
          </Tag>
        ))}
      </div>
      <span className={style.container}>
        <NumberInputWithUnit
          inputWidth={inputWidth}
          margin="0 3px 0 2px"
          value={inputVal}
          setValue={setInputVal}
          onBlur={() => {}}
          direction={direction}
          disabled={disabled}
        >
          {symbol}
        </NumberInputWithUnit>
        <IncrementButton
          disabled={disabled}
          buttonWidth="18px"
          borderRadius="50%"
          width={10}
          stroke={2}
          color={buttonColor}
          backgroundColor={isInList ? buttonBgColor : colors.red}
          paddingPercent={20}
          handleClick={addToList}
        />
      </span>
      <p
        className={style.note}
        style={{ color: valueList.length === 0 ? colors.red : colors.blue }}
      >
        Click <strong>+</strong> to add a value.
      </p>
    </div>
  );
}
ValueListInput.defaultProps = {
  buttonBgColor: colors.blue,
  buttonColor: colors.white,
  disabled: false,
  inputWidth: '50px',
};
ValueListInput.propTypes = {
  currentValues: PropTypes.any.isRequired,
  symbol: PropTypes.string.isRequired,
  onAddDelete: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
  buttonBgColor: PropTypes.string,
  buttonColor: PropTypes.string,
  addDecimals: PropTypes.bool,
  allowRepeats: PropTypes.bool,
  percentageArray: PropTypes.bool,
  disabled: PropTypes.bool,
  inputWidth: PropTypes.string,
};
export default ValueListInput;
